import type { HTMLProps } from "react";
import { twMerge } from "tailwind-merge";

export const H1 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h1
    {...props}
    className={twMerge("text-3xl font-semibold", props.className)}
  />
);

export const H2 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h2
    {...props}
    className={twMerge("text-2xl font-semibold", props.className)}
  />
);

export const H3 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h3
    {...props}
    className={twMerge("text-xl font-semibold", props.className)}
  />
);

export const H4 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h4
    {...props}
    className={twMerge("text-lg font-semibold", props.className)}
  />
);

export const H5 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h5
    {...props}
    className={twMerge("text-base font-semibold", props.className)}
  />
);

export const H6 = (props: HTMLProps<HTMLHeadingElement>) => (
  <h6
    {...props}
    className={twMerge("text-base font-normal text-zinc-500", props.className)}
  />
);
